'use client';

import type { SmartBannerLink } from '@weberus/utils';
import { type FC, useMemo } from 'react';
import { useAtomValue } from 'jotai';
import { AppBannerPopup as AppBanner } from '@weberus/ui/components/app-banner-popup';
import { deviceAtom } from '@/app/_shared/store/device';
import { getCookieValue } from '@/app/_shared/utils/get-cookie-value';

interface AppBannerPopupProps {
  link?: SmartBannerLink;
}

export const AppBannerPopup: FC<AppBannerPopupProps> = ({ link }) => {
  const { deviceType } = useAtomValue(deviceAtom);

  const smartBannerLink: SmartBannerLink = useMemo(() => {
    if (typeof window === 'undefined') {
      return {};
    }

    return {
      path: link?.path || `${location.origin}${location.pathname}`,
      linkType: link?.path ? 'deepLink' : 'webviewLink',
      cgntId: getCookieValue('cgntId') ?? undefined,
      ...link,
    };
  }, []);

  return <AppBanner deviceType={deviceType} link={smartBannerLink} />;
};

export default AppBannerPopup;
